<template>
  <div
    class="rs-settings-row"
    :class="{ 'rs-settings-row--link': link }"
    @click="$emit('click')"
  >
    <div class="row-start">
      <span
        v-if="label"
        class="label"
      >{{ label }}<sup v-if="required">*</sup></span>
      <span
        v-if="value"
        class="value"
      >{{ value }}</span>
      <div
        v-if="hasSlot"
        class="row-content"
      >
        <slot />
      </div>
    </div>

    <div
      v-if="link"
      class="row-end"
    >
      <div class="icon-wrap">
        <RsIcon icon="chevron-right" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'RsSettingsRow',

  props: {
    link: Boolean,
    full: Boolean,
    label: String,
    value: {
      type: String as PropType<string | null>,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasSlot() {
      const slots = Object.keys(this.$slots);
      return slots.includes('default');
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.rs-settings-row{
  display: flex;
  align-items: center;
  padding: .75rem 1em;
  width: 100%;
  border-bottom: 1px solid $extra-light-gray;
  transition: background-color 0.2s ease;
  p{
    margin: 0.5rem 0 0 0;
    font-size: 0.875rem;
    color: $dark-gray;
  }
  label sup, .label sup {
    margin-top: 3px;
  }
  .rs-input{
    margin: 0;
    input.form-control{
      width: 100%;
    }
  }
  .rs-input + .rs-input{
    margin-top: 1rem;
  }
  .rs-radio-group{
    .rs-radio{
      .label{
        color: $black;
      }
    }
  }
  .rs-checkbox-group{
    .rs-checkbox{
      .label{
        color: $black;
      }
    }
  }
  .rs-select{
    margin: 0;
  }
  .row-content{
    flex-grow: 1;
  }
  .row-start{
    display: flex;
    flex: 1;
    & > .label{
      margin: 0;
      padding-right: 1.5rem;
      width: 19rem;
      font-size: 1rem;
      font-weight: 700;
      flex-shrink: 0;
    }
  }
  .row-end{
    display: flex;
    justify-content: flex-end;
    width: 8rem;
    text-align: right;
  }
  &--link{
    cursor: pointer;
    .row-start{
      flex-grow: 1;
      align-items: center;
    }
    .icon-wrap{
      position: relative;
      z-index: 1;
      &:before{
        content: '';
        position: absolute;
        z-index: -1;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        transform: translate(-50%, -50%);
        transform-origin: 50% 50%;
        background-color: rgba($extra-light-gray, 0.5);
        border-radius: 50%;
        transition: all 0.3s;
        opacity: 0;
      }
    }
    &:hover{
      background-color: rgba($extra-light-gray, 0.2);
      .icon-wrap{
        &:before{
          width: 40px;
          height: 40px;
          opacity: 1;
        }
      }
    }
  }
  .rs-button{
    padding: 0.5rem 1rem;
  }
  .rs-card{
    div:last-of-type{
      border-bottom: none;
    }
  }
}
</style>
